import './bootstrap';
import '../css/app.css';
import "@fortawesome/fontawesome-free/css/all.css";
import { preloadLogo } from '@/utils/preloadLogo';

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

preloadLogo();

createInertiaApp({
    /** Título vacío: no forzar sufijo (p. ej. informe final sin « - Infosoft » en impresión). */
    title: (title) => {
        const t = title == null ? '' : String(title).trim()
        if (t === '') return ''
        return `${t} - ${appName}`
    },
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        return createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});


if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/service-worker.js')
        .then((registration) => {
           // console.log('Service Worker registrado con éxito:', registration);
        })
        .catch((error) => {
            console.error('Error al registrar el Service Worker:', error);
        });
}